module.exports = __webpack_public_path__ + "static/media/engine-fan_red.44591575.png";